import ReadyToWithdraw from './ReadyToWithdraw'
export default ReadyToWithdraw
